/**
 * Created by XuQiang on 2017/5/23.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Base64 } from 'js-base64';
import ReservationDialog from '../commons/ReservationDialog';
import PromptInfo from '../../utils/promptInfo.js';
import { CHINESE_HK, FIND_PASSWORD, OPEN_SIGN } from '../../utils/constants';
import './LoginDiv.less';

const DialogType = PromptInfo.DialogType;
const virsical_LOGO = require('../../assets/virsical-LOGO.png');
export default ({ intl, dispatch,menuData, loginData, locale }) => {
  let isChinese = locale === 'zh_CN';
  const { error, checkCodeImg, account, checkCode, checkCodeVisible } = loginData;
  const {domainI18nLogoZH,domainI18nLogoEN,sysNameEN,sysNameZH} = menuData;
  let logImgUrl = ((isChinese || locale === CHINESE_HK) && domainI18nLogoZH) ? domainI18nLogoZH : domainI18nLogoEN ? domainI18nLogoEN : domainI18nLogoZH;
  let sysNameStr = (isChinese && sysNameZH) ? sysNameZH : sysNameEN ? sysNameEN : sysNameZH;
  const back = error.type;
  let backTips = <div className="login-case" />;
  if (back === PromptInfo.USER_VALID) {
    backTips = <div className="login-case" />;
  } else if (back === PromptInfo.USERNAME_ISNULL) {
    backTips = (
      <div className="login-case">
        <FormattedMessage id="index_un_username" />
      </div>
    );
  } else if (back === PromptInfo.PASSWORD_ISNULL) {
    backTips = (
      <div className="login-case">
        <FormattedMessage id="index_un_password" />
      </div>
    );
  } else if (back === PromptInfo.USER_INVALID) {
    backTips = <div className="login-case">{loginData.error.msg}</div>;
  } else if (back === PromptInfo.VERCODE_WRONG) {
    backTips = (
      <div className="login-case">
        <FormattedMessage id="index_verify_code" />
      </div>
    );
  }

  let _password = null;
  let _remember = null;
  return (
    <div className="fix-login">
      {/*<input type="text" style={{opacity:"0",width:"0.1px"}}/>*/}
      {/*<input type="password" style={{opacity:"0",width:"0.1px"}}/>*/}
      <div
        className="title-logo"
        onDoubleClick={() =>
          dispatch({ type: 'login/setDivType', divType: OPEN_SIGN })
        }>
        <span className="logo">
          <img src={logImgUrl || virsical_LOGO} />
        </span>
        <span className="reserve">
          {intl.locale === CHINESE_HK ? intl.formatMessage({ id: 'title_log' }) : sysNameStr}
        </span>
      </div>
      <div className="login-cont">
        <div className="login-type">
          <i className="iconfont icon_username" />
          <input
            type="text"
            placeholder={intl.formatMessage({ id: 'index_login_username' })}
            value={account}
            onKeyUp={() => {//松松说qq也是这样
              const password = localStorage.getItem(account) || '';
              let orPassword = Base64.decode(password);
              _password.value =  orPassword;
              if (orPassword) {
                _remember.checked = true;
              }
            }}
            onChange={e =>
              dispatch({
                type: 'login/update',
                payload: { account: e.target.value }
              })
            }
            maxLength="37"
            onKeyDown={e =>
              keyDown({
                event: e,
                intl,
                username: account,
                password: _password.value,
                checked: _remember.checked,
                dispatch,
                checkCodeVisible
              })
            }
          >
          </input>
        </div>
        <div className="login-type">
          <i className="iconfont icon_pass" />
          <input
            type="password"
            placeholder={intl.formatMessage({ id: 'index_login_password' })}
            ref={ref => (_password = ref)}
            onKeyDown={e =>
              keyDown({
                event: e,
                intl,
                username: account,
                password: _password.value,
                checked: _remember.checked,
                dispatch,
                checkCodeVisible
              })
            }
          />
        </div>
        {
          checkCodeVisible && (
            <div className="login-type login-check-code">
              <i className="iconfont icon-room-shouquan" />
              <input
                type="text"
                placeholder={intl.formatMessage({ id: 'index_login_check_code' })}
                value={checkCode}
                maxLength="6"
                onChange={e =>
                  dispatch({
                    type: 'login/update',
                    payload: { checkCode: e.target.value }
                  })
                }
                onKeyDown={e =>
                  keyDown({
                    event: e,
                    intl,
                    username: account,
                    password: _password.value,
                    checked: _remember.checked,
                    dispatch
                  })
                }
              />
              <div className="code-area">
                <img
                  src={checkCodeImg}
                  onClick={() => dispatch({ type: 'login/getCheckCode' })}
                />
              </div>
            </div>
          )
        }
        <div className="login-check">
          <label>
            <FormattedMessage id="index_remember" />
            <input
              type="checkbox"
              onClick={() =>
                rememberPassword({
                  userId: account,
                  password: _password.value,
                  checked: _remember.checked
                })
              }
              ref={ref => (_remember = ref)}
            />
          </label>
          <a onClick={() => dispatch({type: 'login/setDivType', divType: FIND_PASSWORD})}><FormattedMessage id='index_forgot'/></a>
        </div>
        {backTips}
        <div className="login-btn">
          <a
            onClick={() =>
              userLoginHandle({
                intl,
                username: account,
                password: _password.value,
                checked: _remember.checked,
                dispatch,
                checkCodeVisible
              })
            }
          >
            <FormattedMessage id="index_login" />
          </a>
        </div>
      </div>
    </div>
  );
};

const keyDown = ({ event, username, password, checked, intl, dispatch,checkCodeVisible }) => {
  if (event.keyCode === 13 || event.which === 13) {
    userLoginHandle({ username, password, checked, intl, dispatch,checkCodeVisible });
  }
};

const rememberPassword = ({ userId, password, checked }) => {
  if (checked) {
    localStorage.setItem(userId, Base64.encode(password));
  } else {
    localStorage.removeItem(userId);
  }
};

const userLoginHandle = ({ username, password, checked, intl, dispatch , checkCodeVisible}) => {
  if (!username) {
    dispatch({
      type: 'login/setError',
      error: { type: PromptInfo.USERNAME_ISNULL }
    });
    return;
  }
  if (!password) {
    dispatch({
      type: 'login/setError',
      error: { type: PromptInfo.PASSWORD_ISNULL }
    });
    return;
  }
  const uri_domain = sessionStorage.getItem('uri_domain');
  //uri_domain!=''表示在URL中已打开自已的域。 这种情况下只能登录本域下的用户
  //uri_domain==''表示在根目录下。这种情况下可以允许用户跳到自己输入的域名下。
  if (uri_domain && uri_domain !== '') {
    if (username.indexOf('@') > -1) {
      //输入了域名
      if (username.split('@')[1] !== sessionStorage.getItem('domainName')) {
        ReservationDialog({
          type: DialogType.ERROR,
          locale: intl.formatMessage({ id: 'locale' }),
          message: intl.formatMessage({ id: 'userId_domain_prompt' })
        });
        return;
      }
    } else {
      //没有输入域名的情况
      username = username + '@' + sessionStorage.getItem('domainName');
    }
  } else {
    if (username.indexOf('@') === -1 && sessionStorage.getItem('domainName')) {
      username = username + '@' + sessionStorage.getItem('domainName');
    }
  }
  dispatch({
    type: 'login/userLogin',
    payload: { username, basedn: '', password: password , checkCodeVisible}
  });
  if (checked) {
    rememberPassword({ userId: username, password, checked });
  }
};



// WEBPACK FOOTER //
// ./src/components/login/LoginDiv.js